module.exports = __webpack_public_path__ + "img/next-btn.975a7615.svg";